import styled from "styled-components";

export const Section = styled.section`
  margin-top: 40px;
  width: 100%;
`;

export const SectionTitle = styled.h2`
  color: #000;
  font-family: Poppins;
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
  margin: 0 0 16px;
`;

export const TableWrap = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;

  .ant-table {
    font-family: Inter;
  }
`;
